import classNames from 'classnames';
import Link from 'next/link';

const RoomTypesExplainerItem = ({
  imageUrl,
  imageAlt,
  heading,
  text,
  link,
  buttonText,
  showButton = true,
  wrapImageWithLink = false,
  wrapHeadingWithLink = false,
  displayText = true,
}: {
  imageUrl: string;
  imageAlt: string;
  heading: string;
  text: string;
  link: string;
  buttonText?: string;
  showButton?: boolean;
  wrapImageWithLink?: boolean;
  wrapHeadingWithLink?: boolean;
  displayText?: boolean;
}) => {
  const textClasses = classNames({
    'room-types-explainer__item__text': true,
    'room-types-explainer__item__text--hidden': !displayText,
  });

  const renderImage = () => {
    return wrapImageWithLink ? (
      <Link href={link} data-testid="roomTypeImageLink">
        <img
          src={imageUrl}
          alt={imageAlt}
          className="room-types-explainer__image-with-link"
          data-cy="roomTypeImageWithLink"
        />
      </Link>
    ) : (
      <img src={imageUrl} alt={imageAlt} />
    );
  };

  const renderHeading = () => {
    return wrapHeadingWithLink ? (
      <Link href={link} className="room-types-explainer__heading-with-link">
        <h2 data-cy="roomTypeHeadingWithLink">{heading}</h2>
      </Link>
    ) : (
      <h2>{heading}</h2>
    );
  };

  return (
    <div className="room-types-explainer__item">
      {renderImage()}
      {renderHeading()}
      <p className={textClasses}>{text}</p>
      {showButton && (
        <Link href={link} className="button button--medium button--primary">
          {buttonText}
        </Link>
      )}
    </div>
  );
};

export default RoomTypesExplainerItem;
